module.exports = __webpack_public_path__ + "origin-order1.a3f9c4d8a270f0e764f4.svg";


//////////////////
// WEBPACK FOOTER
// /var/www/borneo/prod/borneo_app/src/assets/vcg/img/origin-order1.svg
// module id = ../../../../../src/assets/vcg/img/origin-order1.svg
// module chunks = styles